export const appToaster = {
  successHead: 'Success',
  errorHead: 'An API Error Occurred',
  warningHead: 'Warning',
  apiErrorHead: 'Error',
  loginSucess: 'You have successfully logged in',
  logoutSucess: 'You have successfully log out',
  loading: 'Please Wait...',
  emptyFields: 'Empty fields',
};